import React from 'react';
import { getWidgetSpecificIsVisible } from '@utils/index';
import { connect } from 'react-redux';
import {
    Container,
    TextRow,
    Text,
    Subtext,
    EditButton
} from "./styles";
const mapStateToProps = function (state: any, ownProps: any) {
    return {
      is_visible: getWidgetSpecificIsVisible(
        state.configuration?.normalisedConfig,
        ownProps.id
      )
    };
  };
  

const EditableInfoItem = (props: any) => {
   const { is_visible , text, subText,styles, isEditable, editText, actions } = props;
   if( !is_visible ) return <></>;
   
   const handleEditClick = () => {
     if (actions?.on_click?.[0] && typeof actions.on_click[0].funCall === "function") {
       actions.on_click[0].funCall(actions.on_click[0].args || {});
     }
   };
   
  return (
    <Container styles={styles}>
      <TextRow>
        <Text>{text}</Text>
        {isEditable && <EditButton onClick={handleEditClick}>{editText}</EditButton>}
      </TextRow>
      <Subtext>{subText}</Subtext>
    </Container>
  );
};

export default connect(mapStateToProps)(EditableInfoItem);